let HelperEbro = () => {

    // if (!Modernizr.picture) {
    //     document.write(`<script src="/templates/assets/dist/js/picturefill.min.js" async></script>`);
    // }

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    const links = document.links;
    for (let i = 0; i < links.length; i++) {
        // PDF
        if (links[i].href.match('\\.pdf$')) {
            links[i].target = '_blank';
        }
        // EXTERNAL
        if (links[i].hostname != window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noopener';
        }
    }

    /// Browse Happy
    if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
        document.querySelector('body').insertAdjacentHTML('afterbegin', `<p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/?locale=en">upgrade your browser</a> to improve your experience.</p>`);
    }



};

export default HelperEbro;